import React from 'react';
import styled from 'styled-components';
import {Detail} from '@forecast-it/design-system';
import {FEATURE_FLAG_TEAMS} from './featureFlagTeams';

const LegendBar = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 16px;
	padding: 10px 14px;
	margin-bottom: 16px;
	background: #ffffff;
	border: 1px solid #d3d3df;
	border-radius: 4px;
`;

const LegendEntry = styled.span`
	display: flex;
	align-items: center;
	gap: 7px;
	white-space: nowrap;
`;

const Swatch = styled.span<{$colour: string}>`
	width: 10px;
	height: 10px;
	border-radius: 2px;
	background: ${props => props.$colour};
`;

/**
 * Fixed colour key for the six teams. Deliberately takes no props: it is a legend for the palette,
 * not a summary of what is currently on screen, so it does not change as filters are applied.
 */
export function TeamLegend(): JSX.Element {
	return (
		<LegendBar data-cy="feature-flag-team-legend">
			<Detail>TEAMS</Detail>
			{FEATURE_FLAG_TEAMS.map(team => (
				<LegendEntry key={team.id}>
					<Swatch $colour={team.colour} />
					<Detail>{team.label}</Detail>
				</LegendEntry>
			))}
		</LegendBar>
	);
}
